/**
 * What each code from the Google sign-in routes means, in the terms of whoever is
 * looking at the screen rather than the terms of the OAuth spec.
 *
 * Shared by the callback page and the login page, because a failure can surface
 * at either one depending on how far the redirect got.
 */
const MESSAGES = {
  google_cancelled: 'Google sign-in was cancelled.',
  google_not_configured: 'Google sign-in is not set up on this server yet.',
  google_email_unverified: 'Google has not verified that email address, so it cannot be used to sign in. Verify it with Google, or sign in with a password.',
  google_no_email: 'Google did not share an email address, which this app needs to identify you.',
  google_no_id: 'Google did not identify the account. Please try again.',
  google_state_missing: 'That sign-in link was incomplete. Please start again.',
  google_state_invalid: 'That sign-in attempt expired. Please start again.',
  google_failed: 'Google sign-in did not complete. Please try again.',
};

/**
 * @param {string} code
 * @returns {string|null} null when the code is not one of ours, so an unrelated
 *   error parameter is not dressed up as a Google failure.
 */
export const describeGoogleSignInError = (code) => {
  if (!code) return null;
  if (MESSAGES[code]) return MESSAGES[code];
  return code.startsWith('google_') ? MESSAGES.google_failed : null;
};

export default describeGoogleSignInError;
